export class AutocompleteApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Admin autocomplete terms
     * @returns AutocompleteResult
     * @throws ApiError
     */
    autocomplete({ entity, field, value, size, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/autocomplete',
            query: {
                'entity': entity,
                'field': field,
                'value': value,
                'size': size,
            },
        });
    }
    /**
     * Public autocomplete terms
     * @returns AutocompleteResult
     * @throws ApiError
     */
    publicAutocomplete({ entity, field, value, size, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/autocomplete/public',
            query: {
                'entity': entity,
                'field': field,
                'value': value,
                'size': size,
            },
        });
    }
}
